import axios from "axios";
import { headers } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchAboutBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-about-banners?populate=*`,
      { headers }
    );
    return response.data.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchAboutDescriptionBanner = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_strapiUrl}/api/frcsit-about-descriptions?populate=*`,
        { headers }
      );
      return response.data.data.slice(-1);
    } catch (error) {
      dynamicFailed("Server Error");
    }
  };

export const fetchKeyObjectives = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-about-key-objectives?sort=Order%3Aasc&populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};

export const fetchObjectivesTrust = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_strapiUrl}/api/frcsit-about-objectives-of-the-trusts?sort=Order%3Aasc&populate=*`,
      { headers }
    );
    return response.data.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
}
};